import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitRevenueAndSobView = createSelector(
  [selectFinancialCockpitState],
  ({ revenueAndSobView }) => revenueAndSobView
)
